<template>
  <div>
    <b-card>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Qts</label>
            <input class="form-control personalise" v-model="qts" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Prix</label>
            <input class="form-control personalise" v-model="prix" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Titre</label>
            <input class="form-control personalise" v-model="titre" />
          </div>
        </div>
      </div>

      <CButton
        @click.prevent="add"
        type="submit"
        size="sm"
        color="warning"
        style="border-radius: 24px; margin-left: 22px"
        ><CIcon name="cil-check-circle" /> Ajouter Traitement service</CButton
      >

      <br /><br />
    </b-card>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";

export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      qts: "",
      prix: "",
      titre: "",
      updateIn: false,
      info_trait_service_id: {},
      info_facture: {},
    };
  },

  created() {
    this.fetch_get_update_trait_service();
  },

  computed: {
    prixVergule(){
      return this.prix+',000';
    },

    prix_ca(){
      return this.prix;
    },
  /*   somme: function () {
      var sum = 0;
      if (this.qts != "" && this.prix != "") {
        sum = Number(this.qts * this.prix) + Number(this.info_facture.somme);
      }
      return sum ;
    }, */

      somme: function () {
      var sommeAncien1= (this.info_facture.somme);
      let str = sommeAncien1;
      var sommeAncien = parseInt(str.replace(",", ""));


      if (this.qts != "" && this.prix != "") {
        var sommeAdd = Number(this.qts * this.prix) *Number(1000);

        var sum = sommeAncien +  sommeAdd;
      }
   else {
    var sum = sommeAncien;
   }
  

     
      return (sum) ;

    },
    //TVA
    TVA: function () {
      return this.somme * Number(0.19);
    },
    //somme TTC
    sommeTTC: function () {
      return (this.somme + this.TVA );
    },

     //start here new code
    //somme vergule
    sommeVergule: function () {
      return this.calculDinarsSomme+","+this.calculMillimesSomme;
    },
    //somme ttc vergule
    sommeTTCVergule: function () {
      return this.calculDinarsTTC+","+this.calculMillimesTTC;
    },
    //tva vergule
    TVAVergule: function () {
      return this.calculDinarsTVA+","+this.calculMillimesTVA;
    },

    lengthSomme(){
return this.somme.toString().length;
    },
    lengthSommeTTC(){
return this.sommeTTC.toString().length;
    },
    lengthTVA(){
return this.TVA.toString().length;
    },


    calculMin3Somme(){
      return this.lengthSomme - 3;
    },
      calculMin3TVA(){
      return this.lengthTVA - 3;
    },
    calculMin3TTC(){
      return this.lengthSommeTTC - 3;
    },

    calculDinarsSomme(){
      const a = this.somme.toString();
      return a.substring(0,this.calculMin3Somme);
    },
    calculDinarsTTC(){
      const a = this.sommeTTC.toString();
      return a.substring(0,this.calculMin3TTC);
    },
    calculDinarsTVA(){
      const a = this.TVA.toString();
      return a.substring(0,this.calculMin3TVA);
    },


    calculMillimesSomme(){
      const a = this.somme.toString();
      const b = this.calculDinarsSomme.length;
      return a.substring(b,this.lengthSomme);
    },
    calculMillimesTVA(){
      const a = this.TVA.toString();
      const b = this.calculDinarsTVA.length;
      return a.substring(b,this.lengthTVA);
    },    
    calculMillimesTTC(){
      const a = this.sommeTTC.toString();
      const b = this.calculDinarsTTC.length;
      return a.substring(b,this.lengthSommeTTC);
    },

    somme_fr() {
      const { NumberToLetter } = require("convertir-nombre-lettre");
      const calc =  NumberToLetter(this.calculDinarsTTC);
      return calc +" dinars" + " " +this.calculMillimesTTC +" milimmes";
    },

  /*   lengthSommeTTc(){
return this.sommeTTC.toString().length;
    },

    calculMin3(){
      return this.lengthSommeTTc - 3;
    },

    calculDinars(){
      const a = this.sommeTTC.toString();
      return a.substring(0,this.calculMin3);
    },
    calculMillimes(){
      const a = this.sommeTTC.toString();
      const b = this.calculDinars.length;
      return a.substring(b,this.lengthSommeTTc);
    },

    somme_fr() {
      const { NumberToLetter } = require("convertir-nombre-lettre");
      const calc =  NumberToLetter(this.calculDinars);
      return calc +" dinars" + " " +this.calculMillimes +" milimmes";
    }, */
     

    calculLastNumFac: function () {
         const a = this.last_num_fac.num ;
         const b = parseInt(a);
         return this.numF = b + 1 ;
    },


  },

  methods: {
    add(e) {
      this.updateIn = true;
      let formData = new FormData();

      formData.append("somme", this.sommeVergule);
      formData.append("somme_fr", this.somme_fr);
      formData.append("TVA", this.TVAVergule);
      formData.append("sommeTTC", this.sommeTTCVergule);


      formData.append("titre", this.titre);
      formData.append("qts", this.qts);
      formData.append("prix", this.prixVergule);
      formData.append("prix_ca", this.prix_ca);
  
    

      formData.append("service_id", this.info_trait_service_id.service_id);

      axios
        .post(
          `${apiDomain}/api/addTraitService/${this.$route.params.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )

        .then((res) => {
          this.updateIn = false;
          this.$noty.success("modifiée avec succés ! ");

          this.$router.go(-1);
        })
        .catch((error) => {
          this.updateIn = false;
        });
    },

    fetch_get_update_trait_service() {
      fetch(`${apiDomain}/api/get_TraitService/${this.$route.params.id}`)
        .then((res) => res.json())
        .then((res) => {
          this.info_trait_service_id = res.Traitement;
          this.info_facture = res.Facture;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */

.non_paye {
  position: absolute;
  background: #f10735;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /*  margin-top: -15.6%; */

  margin-top: -16.6% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.paye {
  position: absolute;
  background: #28e40c;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  margin-top: -16.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.en_attente {
  position: absolute;
  background: #c37600;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /*   margin-top: -15.6%; */

  margin-top: -16.6% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

nav {
  display: flex;
  justify-content: center;
}

.pagination {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.pagination li {
  margin: 0 1px;
  padding: 11px 6px !important;
  text-decoration: none;
}

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #2a357d !important;

  color: #ffffff !important;
  -webkit-box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
  box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
}

.pagination > li > a,
.pagination > li > span {
  color: fff;
  list-style-type: cercle;
  border: 0;
  border-radius: -16px !important;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  padding: 9px;
  margin: 0 3px;
  min-width: 31px;
  height: 31px;
  line-height: 30px;
  color: #999999;
  font-weight: 400;
  font-size: 11px;
  text-transform: uppercase;
  background: transparent;
  /* border-color: blue !important; */
  border-radius: 4px;
  background-color: #e88e08 !important;
  /* border-color: #000; */
  color: #fff !important;
}

.index {
  display: inline-block;
  height: 36px;
  width: 36px;
  line-height: 36px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.index_new {
  display: inline-block;
  height: 25px;
  width: 25px;
  line-height: 28px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cer {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: rgb(245 175 19);
}
.cer_green {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: #0ef717;
}
</style>

